import { render, staticRenderFns } from "./FAQStamp.vue?vue&type=template&id=298af486&scoped=true"
import script from "./FAQStamp.vue?vue&type=script&lang=js"
export * from "./FAQStamp.vue?vue&type=script&lang=js"
import style0 from "./FAQStamp.vue?vue&type=style&index=0&id=298af486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298af486",
  null
  
)

export default component.exports